import { useState } from 'react';

const faqs = [
  {
    q: 'How do I place an order on Sweetplate?',
    a: "Download the Sweetplate FOOD APP (available on Android), open it, enter your address, browse restaurants, add items to your cart, and checkout. Your rider will be assigned and on the way in minutes.",
  },
  {
    q: 'How long does delivery take?',
    a: "Most deliveries are completed within 30–60 minutes depending on your location and the restaurant's preparation time. You can track your rider live on the map throughout.",
  },
  {
    q: 'What payment methods are accepted?',
    a: "We accept bank cards, mobile money, and Sweetplate Coins (SPC). All payments are secured and encrypted for your safety.",
  },
  {
    q: 'What are Sweetplate Coins (SPC) and how do I earn them?',
    a: "SPC is our native digital token. You earn SPC on every order you place. You can stake your SPC to earn daily dividends, use them to pay for orders at a discount, or trade them on the market.",
  },
  {
    q: 'How do I register my restaurant on Sweetplate?',
    a: "Visit merchant.sweetplate.org and fill in your restaurant details. Once verified, you can start receiving orders right away through our Vendor App.",
  },
  {
    q: 'How do I become a delivery rider?',
    a: "Download the Rider App (sweetplate.org/sweetplate.apk), complete your profile, submit your verification documents, and start accepting delivery requests in your area on your own schedule.",
  },
  {
    q: 'Is Sweetplate available in my city?',
    a: "We currently operate in 20+ cities across Africa and Asia including Abuja, Accra, Nairobi, Port Harcourt, Enugu, Freetown, Kigali, Nairobi, Bangkok, Hanoi, and more. Check the Locations section for the full list.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block bg-[#FFF8E6] text-[#D4970B] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-5xl font-extrabold text-gray-900 leading-tight">
            Got questions?
          </h2>
          <p className="mt-4 text-gray-500 text-lg max-w-lg mx-auto">
            We&apos;ve got answers. Here are the most common things people ask us.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className={`rounded-2xl border transition-all duration-200 overflow-hidden ${
                open === idx ? 'border-[#009E81]/30 bg-[#F6FFFD]' : 'border-gray-100 bg-white hover:border-gray-200'
              }`}
            >
              <button
                onClick={() => setOpen(open === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="text-sm font-bold text-gray-900 pr-6">{faq.q}</span>
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${
                    open === idx ? 'bg-[#009E81] text-white' : 'bg-gray-100 text-gray-500'
                  }`}
                >
                  <i className={`ri-${open === idx ? 'subtract' : 'add'}-line text-sm`} />
                </span>
              </button>
              {open === idx && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-500 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
